import * as angular from 'angular';
import './truncate.directive.scss';
import { AfterViewInit, Directive, HostListener, Inject, Input, OnInit } from 'ng-metadata/core';

/**
 * @ngdoc directive
 * @name mwTruncate
 * @module mw.components.dataFormatting
 *
 * @param {number} [mw-truncate] - Number of characters for the truncation.
 * @param {boolean} [mw-truncate-is-collapsible] - 'Show less' link will not be showed.
 * @param {string} [mw-truncate-more-text="Show more"] - custom text.
 * @param {string} [mw-truncate-less-text="Show less"] - custom text.
 *
 * @description
 * `mw-truncate` is an attribute directive that will cut the text and add the option to expand it.
 *
 * @usage
 * <hljs hljs-language="html">
 *   <div mw-truncate="10">Long text that might get truncated</div>
 * </hljs>
 *
 */

@Directive({
    selector: '[mwTruncate]'
})
export class TruncateDirective implements AfterViewInit, OnInit {

    private originalText: string = '';
    private truncatedText: string = '';
    private isTruncated: boolean = true;
    private isTruncationEnabled: boolean = true;

    @Input('<') mwTruncate: number;
    @Input('<') mwTruncateIsCollapsible: boolean;
    @Input('<') mwTruncateMoreText: string;
    @Input('<') mwTruncateLessText: string;

    constructor(@Inject('$element') private $element: ng.IRootElementService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$filter') private $filter,
                @Inject('$translate') private $translate) {
        'ngInject';
    }

    ngOnInit() {
        this.mwTruncateIsCollapsible = this.mwTruncateIsCollapsible === false ? false : true;
        this.mwTruncateMoreText = this.mwTruncateMoreText ? this.mwTruncateMoreText : 'Show More';
        this.mwTruncateLessText = this.mwTruncateLessText ? this.mwTruncateLessText : 'Show Less';
    }

    ngAfterViewInit() {
        // Give the element a chance to render
        this.$timeout(() => {
            if (!angular.isUndefined(this.mwTruncate) && this.mwTruncate > 0) {
                const mwTruncateHtml = this.$filter('mwTruncateHtml');
                this.originalText = this.$element.html().trim();
                this.truncatedText = mwTruncateHtml(this.originalText, this.mwTruncate);

                this.mwTruncateMoreText = this.$translate.instant(this.mwTruncateMoreText) || this.mwTruncateMoreText;
                this.mwTruncateLessText = this.$translate.instant(this.mwTruncateLessText) || this.mwTruncateLessText;

                if (this.originalText !== this.truncatedText) this.showTruncated();
                else this.isTruncationEnabled = false;
            }
        }, 0);
    }

    @HostListener('click', ['$event.target'])
    clickOnHostElement(target) {
        if (this.isTruncationEnabled && angular.element(target)[0].className === 'mw-truncate__show-link') {
            if (this.isTruncated) this.showOriginal();
            else this.showTruncated();

            this.isTruncated = !this.isTruncated;
        }
    }

    showOriginal() {
        if (this.mwTruncateIsCollapsible) this.$element.html(`${this.originalText} <a class="mw-truncate__show-link">${this.mwTruncateLessText}</a>`);
        else this.$element.html(`${this.originalText}`);
    };

    showTruncated() {
        this.$element.html(`${this.truncatedText} <a class="mw-truncate__show-link">${this.mwTruncateMoreText}</a>`);
    };

}


// WEBPACK FOOTER //
// ./src/lib/components/data-formatting/truncate.directive.ts